module.exports = __webpack_public_path__ + "img/03.fb917e04.jpeg";